<h1>Transporte de carga eléctrico</h1>

<div class="clearfix">
  <div class="left-hor-bar hor-bar"></div>
  <div class="right-hor-bar hor-bar"></div>
</div>

<section class="content-container">
  <app-home-content-box id="cb-1" color="#2D8BBA" title="Sobre el proyecto" [text]="aboutText"
                        route="/sobre-el-proyecto"></app-home-content-box>
  <app-home-content-box id="cb-2" color="#A6C34E" title="Calculadora TCO" [text]="tcoText"
                        route="/calculadora-intro"></app-home-content-box>
  <app-home-content-box id="cb-3" color="#A3DBD1" title="Preguntas y respuestas" [text]="faqText"
                        route="/faq"></app-home-content-box>
  <div class="home-footer">
    <p>Esta página web pertenece al proyecto "Transporte Eléctrico de carga: Análisis de los
      desafíos para su introducción en Uruguay", financiado por el Fondo Sectorial de Energía (FSE) de la ANII
    </p>
    <p class="remove-margin">Actualizado en marzo 2022</p>
  </div>
</section>

<div class="fill-content"></div>

<app-footer></app-footer>
<!--<div class="title">-->
<!--  <h1>Calculadora TCO</h1>-->
<!--</div>-->

<!--<div class="subtitle">-->
<!--  <p>Calcule el costo total de propiedad de un Camión Diesel, Eléctrico, e Hidrógeno</p>-->
<!--  <a mat-raised-button color="button-green" routerLink="/calculadora">Ir a la Calculadora</a>-->
<!--</div>-->

<!--<app-footer class="footer"></app-footer>-->

<!--<section class="section-2">-->
<!--  <div class="grid-container">-->
<!--    <div class="img-container">-->
<!--      <img src="assets/img/truck-sideways.png" alt="truck sideways">-->
<!--    </div>-->
<!--    <div class="text-container">-->
<!--      <h2>Describa Las Características de los Camiones</h2>-->
<!--      <p>Indique los compenentes y características de su camión a diesel, eléctrico y a hidrógeno. La herramienta lo-->
<!--        ayuda, teniendo varios campos definidos por defecto y siendo otros opcionales.</p>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->

<!--<section class="section-3">-->
<!--  <div class="grid-container">-->
<!--    <div class="right-image-container">-->
<!--      <img src="assets/img/money-comparison.jpg" alt="coins">-->
<!--    </div>-->
<!--    <div class="text-container right-text-container">-->
<!--      <h2>Compare los resultados</h2>-->
<!--      <p>Vea sus resultados del TCO del camión diesel, eléctrico e hidrógeno y compárelos. Mire en los gráficos de dónde-->
<!--        surgen los costos en cada uno de los camiones.</p>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->
